export default __webpack_public_path__ + "media/images/clippy_frame.png";